import { mapToCanActivate, Routes } from "@angular/router";
import { NotAuthGuard } from "src/app/_guards/not-auth.guard";
import { AuthGuard } from "src/app/_guards/auth.guard";
import { SuperadminGuard } from "src/app/_guards/superadmin.guard";

export const ROUTES: Routes = [
    { path: "", redirectTo: "auth", pathMatch: "full" },
    {
        path: "auth",
        loadComponent: () => import("src/app/auth/auth.component").then((m) => m.AuthComponent),

        loadChildren: () => import("src/app/auth/auth-routes").then((m) => m.ROUTES),
        canActivate: mapToCanActivate([NotAuthGuard]),
    },
    {
        path: "app",
        loadComponent: () => import("src/app/app-layout/app-layout.component").then((m) => m.AppLayoutComponent),

        loadChildren: () => import("src/app/app-layout/app-layout-routes").then((m) => m.ROUTES),
        canActivate: mapToCanActivate([AuthGuard]),
        canActivateChild: mapToCanActivate([AuthGuard, SuperadminGuard]),
    },
];
